/**
 * 템플릿 서버 설정
 */

// 템플릿 서버의 기본 URL
// 빈 문자열이면 상대 경로 사용 (현재 도메인 기준)
export const TEMPLATE_BASE_URL = process.env.REACT_APP_TEMPLATE_BASE_URL || '';

// 템플릿 폴더 경로
export const TEMPLATES_PATH = '/Templates';

/**
 * 템플릿 ZIP 파일의 전체 URL 생성
 * 새로운 구조: /Templates/template_0001/template_0001.zip
 */
export function getTemplateZipUrl(templateName: string): string {
  const baseUrl = TEMPLATE_BASE_URL || '';
  return `${baseUrl}${TEMPLATES_PATH}/${templateName}/${templateName}.zip`;
}

/**
 * 썸네일 이미지의 전체 URL 생성
 * 새로운 구조: /Templates/template_0001/thumbnails/thumb_1200x1200.jpg
 */
export function getThumbnailUrl(templateName: string, thumbnailFileName: string): string {
  const baseUrl = TEMPLATE_BASE_URL || '';
  return `${baseUrl}${TEMPLATES_PATH}/${templateName}/thumbnails/${thumbnailFileName}`;
}

/**
 * 템플릿 목록을 가져오는 URL (서버에서 목록 API를 제공하는 경우)
 * 디렉터리 리스팅이 비활성화된 경우 사용
 */
export function getTemplatesListUrl(): string {
  const baseUrl = TEMPLATE_BASE_URL || '';
  return `${baseUrl}${TEMPLATES_PATH}/templates.json`;
}

